import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "2rem",
  backgroundColor: theme.color.border_gray,
  borderRadius: "1rem",
}));

const SoldCntBox = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "1.2rem",
  lineHeight: "1.6rem",
});

const FollowWrapper = styled.div({
  display: "flex",
  gap: "2rem",
});

const FollowBox = styled.div(({ theme }) => ({
  display: "flex",
  gap: "0.5rem",
  fontWeight: theme.fontWeight.medium,

  ".number": {
    fontWeight: theme.fontWeight.black,
  },
}));

type Props = {
  soldCnt: number;
  follower: number;
  following: number;
  userId: number;
  userName: string;
};
const FollowStatus = ({
  soldCnt,
  follower,
  following,
  userId,
  userName,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`/follow/${userId}`, {
      state: {
        userName,
      },
    });
  };

  return (
    <Container onClick={handleNavigate}>
      <SoldCntBox>
        <Image
          src={theme.image.tag_icon.default}
          width="1.6rem"
          height="1.6rem"
        />
        <span>
          {soldCnt} {t("판매 개수")}
        </span>
      </SoldCntBox>

      <FollowWrapper>
        <FollowBox>
          <span className="number">{follower}</span>
          <span>{t("팔로워")}</span>
        </FollowBox>

        <FollowBox>
          <span className="number">{following}</span>
          <span>{t("팔로잉")}</span>
        </FollowBox>
      </FollowWrapper>
    </Container>
  );
};

export default FollowStatus;
